var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.93 32.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #003e4c;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #003e4c;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.42,
    y: 1.43,
    width: 28.62,
    height: 34.41,
    rx: 4.12,
    ry: 4.12,
    transform: "translate(37.36 -.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.4,
    y: -2.4,
    width: 28.62,
    height: 34.41,
    rx: 4.12,
    ry: 4.12,
    transform: "translate(32.51 -2.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10.89,23.28c-.17,0-.29-.05-.39-.15-.09-.1-.14-.22-.14-.37V7.95c0-.17.05-.3.14-.4.09-.1.22-.15.39-.15h5.76c1.12,0,2.09.18,2.91.54.82.36,1.46.9,1.92,1.62s.68,1.61.68,2.69-.23,1.97-.68,2.68-1.09,1.25-1.92,1.61c-.82.36-1.8.54-2.91.54h-4.01v5.67c0,.15-.05.28-.15.37s-.23.15-.4.15h-1.2Zm1.72-8.1h3.92c1.12,0,1.96-.25,2.52-.75.56-.5.84-1.23.84-2.18s-.27-1.66-.82-2.18-1.39-.77-2.54-.77h-3.92v5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m27.07,24.33c-.84,0-1.51-.26-2-.78s-.77-1.22-.82-2.12c0-.11-.01-.24-.01-.41s0-.3.01-.41c.03-.58.17-1.08.4-1.52s.56-.77.97-1.01c.41-.24.89-.35,1.45-.35.62,0,1.14.13,1.56.39.42.26.74.63.96,1.11s.33,1.04.33,1.69v.21c0,.09-.03.16-.08.21-.05.05-.12.07-.2.07h-4.23v.11c.02.33.09.65.22.93s.32.52.56.7c.24.18.54.27.88.27.29,0,.54-.04.73-.13.2-.09.35-.19.48-.3s.2-.19.24-.25c.07-.11.13-.17.17-.19.04-.02.11-.03.2-.03h.59c.08,0,.15.02.2.07.05.04.08.11.07.19,0,.12-.07.27-.2.45-.12.18-.3.35-.52.52-.23.17-.5.31-.83.42-.33.11-.7.17-1.12.17Zm-1.66-3.76h3.35v-.04c0-.37-.07-.69-.2-.98-.13-.28-.33-.51-.58-.68-.25-.17-.55-.25-.9-.25s-.65.08-.9.25-.44.39-.57.68c-.13.29-.2.61-.2.98v.04Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);
export default __webpack_public_path__ + "static/media/Pe.3381e976ed5a4f4102888dac134ed65e.svg";
export { ForwardRef as ReactComponent };